import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
//
import DashboardSidebar from "../dashboard/DashboardSidebar";
import { connect } from "react-redux";
import DashboardNavbar from "../dashboard/DashboardNavbar";
import { Grid } from "@mui/material";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  //overflow: 'hidden'
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  //overflow: 'auto',
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("md")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2)
  },
}));

// ----------------------------------------------------------------------

const dashboard = function DashboardLayout(props) {
  const [open, setOpen] = useState(false);

  useEffect(async () => {
    await props.resetFilters();
    props.updateDateFilters();
    props.getPromise_1();
    props.getPromise_2();
    props.getPromise_3();
    props.getPromise_4();
    props.getPromise_5();
    props.getPromise_6();
    props.getPromise_7();
    props.getPromise_8();
    props.getPromise_9();
    // props.loadData();
  }, []);

  return (
    <Grid container>
      <Grid item md={2}>
        <DashboardSidebar
          isOpenSidebar={open}
          onCloseSidebar={() => setOpen(false)}
        />
      </Grid>
      <Grid item sm={12} md={10}>
        <DashboardNavbar onOpenSidebar={() => setOpen(true)}></DashboardNavbar>
        <MainStyle>
          <Outlet />
        </MainStyle>
      </Grid>
    </Grid>
  );
};

const mapState = (state) => ({});

const mapDispatch = ({
  options: { getHospitals, getPlaces, getLabs },
  charts: { getModel1, getModel2 },
  overview: {
    loadData,
    getPromise_1,
    getPromise_2,
    getPromise_3,
    getPromise_4,
    getPromise_5,
    getPromise_6,
    getPromise_7,
    getPromise_8,
    getPromise_9
  },
  filters: { updateDateFilters, resetFilters },
}) => ({
  resetFilters: () => resetFilters(),
  updateDateFilters: () => updateDateFilters(),
  getHospitals: () => getHospitals(),
  getPlaces: () => getPlaces(),
  getLabs: () => getLabs(),
  getModel1: () => getModel1(),
  getModel2: () => getModel2(),
  getPromise_1: () => getPromise_1(),
  getPromise_2: () => getPromise_2(),
  getPromise_3: () => getPromise_3(),
  getPromise_4: () => getPromise_4(),
  getPromise_5: () => getPromise_5(),
  getPromise_6: () => getPromise_6(),
  getPromise_7: () => getPromise_7(),
  getPromise_8: () => getPromise_8(),
  getPromise_9: () => getPromise_9(),
  loadData: () => loadData(),
});

export default connect(mapState, mapDispatch)(dashboard);
